import React from "react";

import "./LockExercise.scss";
import { Trans, withTranslation } from "react-i18next";
import ExerciseHeader from "./header/ExerciseHeader";
import LoadingScreen from "./ExerciseForm/LoadingScreen";
import { Col, Container, Row } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

function LockExercise({
  exerciseName,
  exerciseBackgroundImage,
  requiredData
}) {
  if (!requiredData) return <LoadingScreen />;

  return (
    <>
      <ExerciseHeader nameOfExercise={exerciseName} />
      <div
        className={"overlay"}
        style={{ backgroundImage: `url(${exerciseBackgroundImage})` }}
        title={exerciseName}
      />
      <Container className="my-auto lock-exercise-container d-flex flex-column justify-content-center align-items-center">
        <Row className={"mb-2"}>
          <Col className={"h1"}>
            <FontAwesomeIcon className={"me-3"} icon="lock" />
            <Trans i18nKey={"page.lock.header"}>Cvičení je zamčené.</Trans>
          </Col>
        </Row>
        <Row className={"mb-0"}>
          <Col className={"h5"}>
            <Trans i18nKey={"page.lock.subHeader"}>
              Vyučující ho musí nejdříve odemknout.
            </Trans>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default withTranslation()(LockExercise);
